module.exports = __webpack_public_path__ + "static/media/Home-warranty-navy-blue.aed790e1.gif";